module.exports = __webpack_public_path__ + "static/media/project2.1d0cf128.jpg";